export type TenantAccessRole = 'member' | 'tenant_admin' | undefined;

export function canProcessTenant(role: TenantAccessRole, superAdmin = false, demoMode = false): boolean {
  return demoMode || superAdmin || role === 'member' || role === 'tenant_admin';
}

export function canManageTenant(role: TenantAccessRole, superAdmin = false, demoMode = false): boolean {
  return demoMode || superAdmin || role === 'tenant_admin';
}
